import config from "../config.js";
import RequestManager from "./request.js";

export default class Prat{
    constructor(obj){
        this.CODE_PRAT = obj.CODE_PRAT
        this.NOM_PRAT = obj.NOM_PRAT
        this.NUMERO_SERIE = obj.NUMERO_SERIE
        this.NUMERO_LICENCE = obj.NUMERO_LICENCE
        this.PRODUIT = obj.PRODUIT
        this.NUM_CONTRAT = obj.NUM_CONTRAT
    }

    static getAllPrat() {
        const url = config.urlBackEnd + "Prat/getAllPrat";
        return  RequestManager.get(url);
    }

    static getPratById(id) {
        const url = config.urlBackEnd + 'Prat/getPratByCode?code=' + id;
        //return fetch(config.urlBackEnd + 'Prat/getPratByCode?code=' + id)
        //    .then(response => { return response.json() })
        //    .then(data => { return  data})
        //    .catch(error => alert('Erreur dans Prat getPatientById fetch'));
        return RequestManager.get(url);
    }

    static getPratBySearch(critere) {
        const url = config.urlBackEnd + 'Prat/getPratBySearch?critere=' + critere;
        //return fetch(config.urlBackEnd + 'Prat/getPratBySearch?critere=' + critere)
        //    .then(response => { return response.json() })
        //    .then(data => { return data })
        //    .catch(error => alert("Erreur dans Prat getPatientBySearch" + error));
        return RequestManager.get(url);
    }

    static getLesProd() {
        var url = config.urlBackEnd + 'Prat/getLesProds'
        //return fetch(url)
        //    .then(response => { return response.json(); })
        //    .then(data => { return data; })
        //    .catch(error=> alert("Erreur dans Prat getLesProd" + error))
        return RequestManager.get(url);
    }

    static getLesModByProd(prod) {
        var url = config.urlBackEnd + "Prat/getLesModules?codeProduit=" + prod;
        url = encodeURI(url);
        //url = "https://localhost:44301/Prat/getLesModules?codeProduit=001%20sasasa";
        return RequestManager.get(url)
    }

    static getPratByNameAndProd(NOM_PRAT, PRODUIT) {
        var url = config.urlBackEnd + 'Prat/getPratByNameAndProd?NOM_PRAT=' + NOM_PRAT + "&PRODUIT=" + PRODUIT
        url = encodeURI(url);
        return RequestManager.get(url);
    }

    static decodeLicenceForModuleBoolean(NUMERO_LICENCE) {
        var url = config.urlBackEnd + "Prat/decodeLicenceForModuleBoolean?NUMERO_LICENCE=" + NUMERO_LICENCE
        url = encodeURI(url)

        //return fetch(url)
        //    .then(response => { return response.json() })
        //    .then(data => { return data })
        //    .catch(error => { alert(" Erreur dans Prat decodeLicenceForModuleBoolean " + error) })
        return RequestManager.get(url);
    }

    static decodeLicenceForModule(NUMERO_LICENCE) {
        var url = config.urlBackEnd + "Prat/decodeLicenceForModule?NUMERO_LICENCE=" + NUMERO_LICENCE
        url = encodeURI(url)
        return RequestManager.get(url);
    }

    static GetNameOfPratBySearch(critere) {
        const url = config.urlBackEnd + 'Prat/GetNameOfPratBySearch?critere=' + critere;
        return RequestManager.get(url);
    }

    static GetPratByNumLicence(NUMERO_LICENCE) {
        var url = config.urlBackEnd + 'Prat/GetPratByNumLicence?NUMERO_LICENCE=' + NUMERO_LICENCE;
        url = encodeURI(url)
        return RequestManager.get(url);
    }

    //codage(NUMERO_SERIE As String, possede As String, produit As String, validite As String)
    static codage(NUMERO_SERIE, possede, produit, validite) {
        /*alert(possede);*/
        var url = config.urlBackEnd + "Prat/codage?NUMERO_SERIE=" + NUMERO_SERIE + "&possede=" + possede + "&produit=" + produit + "&validite=" + validite;
        
        url = encodeURI(url);
        return RequestManager.get(url)
            .then(response => { return response })
            .catch(error => console.error("Prat.codage(NUMERO_SERIE, possede, produit, validite) -->", error));
    }

    static ecrire(jsonPrat) {
        //var url = config.urlBackEnd + "Prat/ecrire?jsonPrat=" + jsonPrat;
        var url = config.urlBackEnd + "Prat/ecrire";
        url = encodeURI(url);
        return RequestManager.post(url, jsonPrat)
            .then(response => {
                return response;
            })
            .catch(error => {console.error("Prat.ecrire(jsonPrat)", error) });
    }

    static GetPratByNumLicence(NUMERO_LICENCE) {
        var url = config.urlBackEnd + 'Prat/GetPratByNumLicence?NUMERO_LICENCE=' + NUMERO_LICENCE;
        url = encodeURI(url)
        return RequestManager.get(url)
            .then(response => { return response; });
    }
}
